jQuery(document).ready(function($) {
	if (!window.WebAssessmentCharts) {
		window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
	}

	// Strips the `PCI-DSS-<major>-<minor>-` framework/version prefix so that
	// numeric control IDs like `PCI-DSS-4-0-12.5.2` become `12.5.2` and can be
	// treated the same way numeric CIS safeguard IDs are.
	const PCI_DSS_PREFIX_REGEX = /^PCI-DSS-\d+-\d+-/i;
	function stripPciDssPrefix(controlId) {
		if (typeof controlId !== 'string') {
			return controlId;
		}
		return controlId.replace(PCI_DSS_PREFIX_REGEX, '');
	}

	// Extracts the top-level numeric requirement (e.g. "12" from "12.5.2")
	function getPciDssCategory(controlId) {
		const numericId = stripPciDssPrefix(controlId);
		if (!numericId) {
			return null;
		}
		return numericId.split('.')[0];
	}

	let projectID;
	if ($('body').hasClass('single-projects')) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
			console.log('Extracted projectID:', projectID);
		}
	}

	// Now using utility function from fetchProjectChartData.js
	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	// Fetch project data and standard data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
		}

		try {
			const projectDataPromise = WebAssessmentCharts.fetchProjectChartData(projectID);
			const [projectData] = await Promise.all([projectDataPromise]);

			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}

			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('Processed Items:', processedItems);

			// Fetch PCI DSS standards data
			try {
				const response = await jQuery.ajax({
					url: controlsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: '2024',
						apis: ['CS'],
						CSLstandardID: 'PCI-DSS-4-0'
					}
				});

				console.log('PCI DSS Standards response structure:', JSON.stringify(response, null, 2));
				WebAssessmentCharts.pciDssStandardData = response;

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid PCI DSS standards response structure:', response);
					return;
				}

				WebAssessmentCharts.PCIDSS(processedItems, response);

			} catch (error) {
				console.error('Error fetching PCI DSS standards:', error);
				// Fall back to rendering with project data only
				WebAssessmentCharts.PCIDSS(processedItems);
			}

		} catch (error) {
			console.error('Error processing data:', error);
		} finally {
			$('.modal-body .loader').hide();
		}
	};

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		WebAssessmentCharts.registerHomeDashboardFetcher('pci-dss-4-0', WebAssessmentCharts.fetchDataAndCalculateScores);
	}

	// Now using utility function from calculateMaturityScore.js
	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;

	// Now using utility function from getMostRecentSafeguards.js
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;

	// Now using utility function from processUniqueItemsCIS.js
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;

	WebAssessmentCharts.calculatePciDssCategoryAverages = function(items, standardData) {
		const categoryScores = {};
		const categoryPotentialCounts = {};

		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					const category = getPciDssCategory(control.controlid.S);
					if (category === null || category === undefined) {
						return;
					}
					if (!categoryPotentialCounts[category]) {
						categoryPotentialCounts[category] = 0;
					}
					categoryPotentialCounts[category]++;
				}
			});
		}
		console.log('PCI DSS Category potential counts: ', categoryPotentialCounts);

		Object.keys(categoryPotentialCounts).forEach(category => {
			categoryScores[category] = {
				total: 0,
				count: 0,
				notApplicableCount: 0,
				totalItems: 0,
				potentialCount: categoryPotentialCounts[category]
			};
		});

		items.forEach(item => {
			if (!item.safeguardid || !item.safeguardid.S) {
				return;
			}
			const category = getPciDssCategory(item.safeguardid.S);
			if (category === null || category === undefined) {
				return;
			}
			const maturityScore = item.maturityscore; // Can be null
			const policyStatus = item.policystatus ? item.policystatus.N : null;

			if (!categoryScores[category]) {
				categoryScores[category] = {
					total: 0,
					count: 0,
					notApplicableCount: 0,
					totalItems: 0,
					potentialCount: categoryPotentialCounts[category] || 0
				};
			}

			categoryScores[category].totalItems++;

			// Not Applicable (policy status 1)
			if (policyStatus === "1") {
				categoryScores[category].notApplicableCount++;
			} else if (maturityScore !== null) {
				categoryScores[category].total += maturityScore;
				categoryScores[category].count++;
			}
		});

		const averages = {};
		Object.keys(categoryScores).forEach(category => {
			const { total, count, notApplicableCount, totalItems, potentialCount } = categoryScores[category];

			// All items marked Not Applicable -> treat the category as null
			if (notApplicableCount === totalItems && totalItems > 0) {
				averages[category] = null;
			} else {
				const applicableCount = potentialCount ? (potentialCount - notApplicableCount) : count;
				averages[category] = applicableCount > 0 ? total / applicableCount : 0;
				console.log(`PCI DSS Category ${category}: total=${total}, potentialCount=${potentialCount}, notApplicableCount=${notApplicableCount}, applicableCount=${applicableCount}, average=${averages[category]}`);
			}
		});

		console.log('PCI DSS Category averages: ', averages);
		return averages;
	};

	WebAssessmentCharts.PCIDSS = function(items, standardData) {
		console.log('Starting PCIDSS function...');
		const tableBody = document.querySelector('#pci-dss tbody');
		if (!tableBody) {
			console.error('PCI DSS Table body not found.');
			return;
		}

		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});

		const allSafeguards = new Map();
		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" }, // Default to "Not Answered"
						maturityscore: 0
					});
				}
			});
		}

		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			if (item && item.safeguardid && item.safeguardid.S) {
				allSafeguards.set(item.safeguardid.S, item);
			}
		});

		const mergedItems = Array.from(allSafeguards.values());
		console.log('PCI DSS merged items (including unanswered):', mergedItems);

		const averageScores = WebAssessmentCharts.calculatePciDssCategoryAverages(mergedItems, standardData);

		const rowsToRemove = [];

		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});

		// Update the table: top-level requirement number -> row index (1 -> row 0, 2 -> row 1, ...)
		Object.keys(averageScores).forEach(category => {
			const rowIndex = parseInt(category, 10) - 1;
			const row = tableBody.rows[rowIndex];
			if (row) {
				const averageScore = averageScores[category];
				const scoreCell = row.cells[1];

				if (averageScore === null) {
					rowsToRemove.push(row);
				} else {
					const scaledScore = averageScore * 5; // Scale to out of 5
					scoreCell.textContent = scaledScore.toFixed(2);
					console.log(`Updated PCI DSS row ${rowIndex + 1} with averageScore:`, scaledScore.toFixed(2));
				}
			} else {
				console.warn(`PCI DSS row not found for category ${category} with rowIndex ${rowIndex}`);
			}
		});

		rowsToRemove.forEach(row => {
			row.remove();
		});

		// Overall maturity score
		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row) => {
			const scoreText = row.cells[1].textContent;
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		});

		const maturityRatingRow = $('#pci-dss .light-background td');
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			const overallMaturity = totalScore / scoreCount;
			WebAssessmentCharts.overallPCIDSSmaturity = overallMaturity;

			maturityRatingRow.text(overallMaturity.toFixed(2));
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.pci-dss-overall-value').text(overallMaturity.toFixed(2));
			console.log(`Updated PCI DSS overall maturity rating to ${overallMaturity.toFixed(2)}`);

			$('.spinner-border').hide();
			$('.mark-complete-modal-buttons').show();
		} else {
			console.error('Error: No scores found or maturity rating row not found in the PCI DSS table.');
		}

		$('.pci-dss-container').show();
		WebAssessmentCharts.createChartFromTable('pci-dss', 'pci-dss-chart', charts, true);

		// Restore any removed rows (kept hidden) so original indices stay stable for later runs
		rowsToRemove.forEach(row => {
			const originalIndex = originalIndices.get(row);
			if (originalIndex !== undefined) {
				tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
				row.style.display = 'none';
			}
		});
	};

	// Object to keep track of charts
	var charts = {};

	$('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');

		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		dataTable.toggle();

		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20;

			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable;
			} else {
				$button.text('View Table');
				$targetElement = card;
			}

			var currentScrollTop = $scrollContainer.scrollTop();
			var targetTop = $targetElement[0].getBoundingClientRect().top;
			var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;

			var scrollOffset = targetTop - containerTop - headerOffset;
			var newScrollTop = currentScrollTop + scrollOffset;

			$scrollContainer.scrollTop(newScrollTop);

		}, 10);

		// Hack for the modal height to make it work across browsers
		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});

	viewResultsProject = window.location.href;
	let currentProjectID = '';

	if (viewResultsProject.includes('#')) {
		currentProjectID = viewResultsProject.split('#')[1];
	}

	if (!currentProjectID) {
		const projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1];
		}
	}

	$('.view-results').on('click', function() {
		$('.modal-body .loader').show();
		let projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1].split(/[?#]/)[0];
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		}
	});

	$(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
		if (currentProjectID) {
			console.log('Project Complete Modal detected with Project ID:', currentProjectID);
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		} else {
			console.error('Project ID not found for #projectCompleteModal');
		}
	});
});
